import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { KundeninfoLeisteComponent } from '@softapps/fibu/core';
import { OffenePostenWidgetComponent } from '@softapps/fibu/offene-posten';
import { KreditlimitWidgetComponent } from '@softapps/wws/kreditlimit';
import { UmsatzstatistikWidgetComponent } from '@softapps/wws/umsatzstatistik';
import { backNavigation } from '@softline/application';
import { map } from 'rxjs';

@Component({
  selector: 'soft-kundenabfrage-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrl: './customer-detail.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    KundeninfoLeisteComponent,
    OffenePostenWidgetComponent,
    KreditlimitWidgetComponent,
    UmsatzstatistikWidgetComponent,
  ],
})
export class CustomerDetailComponent {
  private readonly activatedRoute = inject(ActivatedRoute);

  readonly idktostamm = toSignal(
    this.activatedRoute.paramMap.pipe(
      map((o) => o.get('id')),
      map((id) => (id && !isNaN(+id) ? +id : null))
    ),
    { initialValue: null }
  );

  readonly kundennummer = toSignal(
    this.activatedRoute.queryParamMap.pipe(map((o) => o.get('nummer'))),
    { initialValue: null }
  );

  // The widgets load once on init, so switching the customer has to re-create them.
  readonly customers = computed(() => [{ idktostamm: this.idktostamm() }]);

  constructor() {
    backNavigation('/kundenabfrage');
  }
}
